<template>
  <div id="Report">
    <div id="Report-top"></div>
    <div id="Report-body">
      <p class="Report-title">中国儿童青少年体育健身指数</p>
      <p class="Report-title-content">为客观评价我国儿童青少年体育健身发展水平，诊断当前影响儿童青少年参与体育健身的阻碍因素，进一步完善儿童青少年体育健身服务体系，促进全国儿童青少年体质健康水平的提高，我们对2017年全国儿童青少年体育健身发展水平进行了调研与评估，数据来源于2017年教育部学生体质健康复核抽测和青少年学生体育健身现状调查所获得的数据。包括我国30个省（自治区、直辖市）和新疆生产建设兵团的儿童青少年、家长以及所在学校的体育教师，共26余万有效样本。</p>
      <div class="Report-parent-Children-Teacher"></div>
      <p class="Report-parent-Children-Teacher-content">从环境、行为和效果三个维度对儿童青少年体育健身情况进行评估，在11个二级指标的基础上设置了49个观测指标。</p>
      <div class="Report-Indicator-Directed-Graph"></div>
      <div class="Report-National-index-score-distribution-map"></div>
      <div class="Report-Total-Score-And-Each-Dimension-Score">
        <div class="Report-Total-Score-And-Each-Dimension-Score-title">
          <p>全国儿童青少年体育健身指数<br><span style="font-size: 24px;">总得分及各维度得分</span></P>
          <p class="score">60.2</p>
        </div>
        <div class="Report-Total-Score-And-Each-Dimension-Score-img"></div>
        <div class="Report-Total-Score-And-Each-Dimension-Score-content"><p>1）体育健身指数达60分以上有17个省。<br>2）我国儿童青少年体育健身状况总体上处于及格水平，未来提升空间很大。<br>3）补齐“健身行动”短板，是提升我国儿童青少年体育健身发展水平的重点。</p></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  mounted() {
    this.changStyle();
  },
  methods: {
    changStyle() {
      var serviceA=document.getElementById('serviceA');
      serviceA.style.color='#000';
      serviceA.style['font-weight'] = 'normal';
      serviceA.onmouseover=function(){
        serviceA.style.color='#74B6EC';
      }
      serviceA.onmouseout=function(){
        serviceA.style.color='#000';
      }
      var solutionA=document.getElementById('solutionA');
      solutionA.style.color='#000';
      solutionA.style['font-weight'] = 'normal';
      solutionA.onmouseover=function(){
        solutionA.style.color='#74B6EC';
      }
      solutionA.onmouseout=function(){
        solutionA.style.color='#000';
      }
    }
  }
}
</script>

<style lang="scss">
#Report{
  margin: 0 auto;
  text-align: center;
}
#Report-top{
  padding-top: 60px;
}
#Report-top{
  height: 600px;
  background-size: auto 100%;
  background-position:center;
  background-repeat: no-repeat;
  background-image: url(../assets/images/Report/Report_Banner.png);
}
#Report-body{
  width: 1080px;
  padding-top: 60px;
  text-align: center;
  padding-bottom: 60px;
  display: inline-block;
}
#Report-body .Report-title{
  color: #606060;
  font-size: 30px;
  font-weight: normal;
}
#Report-body .Report-title-content{
  margin: 20px;
  width: 460px;
  text-align: left;
  text-indent: 2em;
  display: inline-block;
}
#Report-body .Report-parent-Children-Teacher-content{
  margin: 20px;
  width: 460px;
  text-align: left;
  text-indent: 2em;
  display: inline-block;
}
#Report-body .Report-parent-Children-Teacher{
  height: 224px;
  background-size: auto 100%;
  background-position:center;
  background-repeat: no-repeat;
  background-image: url(../assets/images/Report/Report_parent_Children_Teacher.png);
}
#Report-body .Report-Indicator-Directed-Graph{
    height: 480px;
    background-size: auto 100%;
    background-position:center;
    background-repeat: no-repeat;
    background-image: url(../assets/images/Report/Report_Indicator_Directed_Graph.png);
}
#Report-body .Report-National-index-score-distribution-map{
    height: 500px;
    margin-bottom: 40px;
    background-size: auto 100%;
    background-position:center;
    background-repeat: no-repeat;
    background-image: url(../assets/images/Report/Report_National_index_score_distribution_map.png);
}
#Report-body .Report-Total-Score-And-Each-Dimension-Score .Report-Total-Score-And-Each-Dimension-Score-title{
  text-align: center;
}
#Report-body .Report-Total-Score-And-Each-Dimension-Score .Report-Total-Score-And-Each-Dimension-Score-title p{
  //width: 208px;
  font-size: 22px;
  text-align: justify;
  display: inline-block;
  text-justify: distribute;
  text-align-last: justify;
  -moz-text-align-last:justify;
}
#Report-body .Report-Total-Score-And-Each-Dimension-Score .Report-Total-Score-And-Each-Dimension-Score-title .score{
  width: auto;
  color:#cdca89;
  font-size: 60px;
}
#Report-body .Report-Total-Score-And-Each-Dimension-Score .Report-Total-Score-And-Each-Dimension-Score-img{
  height: 277px;
  margin-top: 20px;
  background-size: auto 100%;
  background-position:center;
  background-repeat: no-repeat;
  background-image: url(../assets/images/Report/Report-Total-Score-And-Each-Dimension-Score.png);
}
#Report-body .Report-Total-Score-And-Each-Dimension-Score .Report-Total-Score-And-Each-Dimension-Score-content{
  text-align: center;
  margin-top: 20px;
}
#Report-body .Report-Total-Score-And-Each-Dimension-Score .Report-Total-Score-And-Each-Dimension-Score-content p{
  width: 460px;
  color: #909090;
  text-align: left;
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/pages/Report.vue